<template>
  <div class="examples">
    <div class="banner">
      <img src="../assets/images/examples/banner.png" alt="" />
      <div class="text">
        <div class="title">客户才是最好的产品经理 你也可以做设计</div>
      </div>
    </div>

      <el-row :gutter="10">
          <el-col :xs="1" :sm="6" :md="4" :lg="3" :xl="3"><div style="min-height: 36px;"></div></el-col>
          <el-col :xs="23" :sm="6" :md="8" :lg="9" :xl="9">
              <div class="feedbackleft">
                  <p><span style="font-size: 18px;"><b>服务热线：</b>027-85806032</span></p>
                  <p><span style="font-size: 18px;"><b>手机/微信：</b>18602737448     18086104588</span></p>
                  <p><span style="font-size: 18px;"><b>公司地址</b></span><span style="font-weight: 700; font-size: 18px;">：</span><span style="font-size: 18px;">湖北省武汉市江汉区新华路296号IFC国际金融中心1213-16室</span></p>
              </div>
          </el-col>
          <el-col :xs="23" :sm="6" :md="8" :lg="9" :xl="9">
              <div class="feedbackright">
                  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" size="default" class="demo-ruleForm">
                      <div>
                          <div class="colsq"><h4>收到信息，我们会尽快与您联系</h4></div>
                          <div class="form-group col-sm-6">
                              <el-form-item label="试用单位" prop="company">
                                  <el-input v-model="ruleForm.company"></el-input>
                              </el-form-item>
                          </div>

                          <div class="form-group col-sm-6">
                              <el-form-item label="联系人" prop="username">
                                  <el-input v-model="ruleForm.username"></el-input>
                              </el-form-item>
                          </div>

                          <div class="form-group col-sm-6">
                              <el-form-item label="联系方式" prop="phone">
                                  <el-input v-model="ruleForm.phone"></el-input>
                              </el-form-item>
                          </div>

                          <div class="form-group" style="text-align: center">
                              <el-button type="primary" @click="submitForm('ruleForm')">申请试用</el-button>
                          </div>
                      </div>
                  </el-form>
              </div>
          </el-col>
          <el-col :xs="1" :sm="6" :md="4" :lg="3" :xl="3"><div style="min-height: 36px;"></div></el-col>
      </el-row>

  </div>
</template>

<script>
export default {
  name: "lxwm",
  data() {
    return {
        ruleForm: {
            company: '',
            username: '',
            phone: '',
        },

        rules: {
            company: [
                { required: true, message: '请填写试用单位', trigger: 'blur' },
                { min: 3, max: 30, message: '长度在 3 到 30 个字符', trigger: 'blur' }
            ],
            username: [
                { required: true, message: '请填写联系人', trigger: 'blur' },
                { min: 2, max: 6, message: '长度在 2 到 6 个字符', trigger: 'blur' }
            ],
            phone: [
                { required: true, message: '请填写您的手机号码', trigger: 'blur' },
                { min: 11, max: 11, message: '手机号码长度不符', trigger: 'blur' }
            ],
        }
    };
  },
  created() { },
  methods: {
      open() {
          this.$message('提交成功，我们会尽快与您联系！');
          setTimeout(() => {
              location.reload();
          }, 1500);
      },
      submitForm(formName) {
          this.$refs[formName].validate((valid) => {
              if (valid) {
                  let self = this;
                  var url = "index/message";
                  self.$axios.post(self.api.apiurl + url, this.ruleForm).then(function (res) {
                      self.open();
                  })
              } else {
                  return false;
              }
          });
      },
  },
};
</script>

<style lang="scss" scoped>
.feedback{
    width: 120rem;
    margin: 5rem auto;
    overflow: hidden;
}
.feedbackleft{
    margin-top: 5rem;
}
.feedbackright{
    .colsq {
        border-bottom: 1px dashed #d3dae5;
        margin-bottom: 5rem;
        margin-left: 5rem;
        h4{
            font-size: 18px;
        }
    }
    .form-group {
        margin-bottom: 3.5rem;
    }
    .col-sm-6 {
        width: 100%;
    }
    label {
        display: inline-block;
        max-width: 100%;
        margin-bottom: 5px;
        font-size: 17px;
        color: #8e8e8e;
    }
    .form-control {
        display: block;
        width: 95%;
        height: 34px;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.42857143;
        color: #555;
        background-color: #fff;
        background-image: none;
        border: 1px solid #ccc;
        border-radius: 4px;
        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
        -webkit-transition: border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;
        -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
        transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    }
    .btn1 {
        display: inline-block;
        padding: 8px 30px;
        margin-bottom: 0;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.42857143;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-image: none;
        border: 1px solid transparent;
        border-radius: 10px;
        background-color: #0077ff;
        color:#fff;
    }
}

.examples {
  width: 192rem;

  .banner {
    width: 100%;
    position: relative;

    img {
      width: 100%;
        height: 30rem;
    }

    .text {
      position: absolute;
      right: 20rem;
      top: 10rem;
      width: 100rem;

      .title {
        font-size: 4.6rem;
        color: #0077ff;
        margin-bottom: 5rem;
      }

      .subTitle {
        font-size: 2.8rem;
        color: #93969b;
      }
    }
  }

  .examList {
    padding: 5rem 0 10rem 0;
    background: url("../assets/images/examples/bgc.jpg") no-repeat;

    .examTitle {
      width: 128rem;
      margin: 0 auto;
      font-size: 3.6rem;
      padding-bottom: 5rem;
      position: relative;
      text-align: center;

      span {
        display: inline-block;
        position: absolute;
        width: 5rem;
        height: 0.2rem;
        background-color: #35a0dc;
      }

      .line1 {
        left: 48rem;
        top: 2.5rem;
      }

      .line2 {
        right: 48rem;
        top: 2.5rem;
      }
    }

    .examImgs {
      width: 128rem;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      overflow: hidden;

      .box {
        overflow: hidden;
        transition: all 0.5s ease-in-out;
        position: relative;

        .modal {
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 9;
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          padding-top: 20rem;

          div {
            color: #fff;
            font-size: 1.4rem;
            font-weight: 300;
            text-align: center;
          }

          .modalTitle {
            margin-bottom: 1rem;
          }
        }
      }
    }
  }

  .hospitals {
    width: 128rem;
    margin: 0 auto;
    padding: 5rem 0;

    .hosTitle {
      font-size: 3.6rem;
      padding-bottom: 5rem;
      position: relative;
      text-align: center;

      span {
        display: inline-block;
        position: absolute;
        width: 5rem;
        height: 0.2rem;
        background-color: #35a0dc;
      }

      .line1 {
        left: 48rem;
        top: 2.5rem;
      }

      .line2 {
        right: 48rem;
        top: 2.5rem;
      }
    }

    .hosItems {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;

      .item {
        img {
          width: 30rem;
          //cursor:pointer
        }

        .name {
          width: 30rem;
          text-align: center;
          padding: 1.2rem 0 3rem 0;
          font-size: 1.8rem;
          font-weight: 400;
        }

      }
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.6s ease-in-out;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
@media screen and (max-width: 750px) {
  .examples{
    .banner{
      .text{
        right: 15rem;
        width: 112rem;
        top:1rem;
      }
    }
    .examList{
      height: 150rem;
      .examTitle{
        font-size: 7.6rem;
        .line1{
          display: none;
        }
        .line2{
          display: none;
        }
      }
      .examImgs{
        height: 130rem;
      }
    }
    .hospitals{
      .hosTitle{
        font-size: 7.6rem;
        .line1{
        display: none;
      }
      .line2{
        display: none;
      }
      }

    }
  }
}
</style>
